import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import ExcelIcon from '../../assets/icons/excel.svg';
import SaveIcon from '../../assets/icons/save.svg';
import withUnsavedChangesGuard from '../../utils/navigationGuard';
import Reset from '../../assets/icons/refresh.svg';

interface GridHeaderProps {
  isQuarterly: boolean;
  onToggle?: (value: boolean | false) => void;
  onSave?: () => void;
  isSummary?: boolean;
  onExport?: () => void;
  disabled?: boolean;
  hasChanges?: boolean;
  onRefresh?: () => void;
  filterInfo?: {
    year?: number | null;
    customerName?: string | null;
    categoryName?: string | null;
    brandName?: string | null;
  };
}

const GridHeader: React.FC<GridHeaderProps> = ({
  isQuarterly,
  isSummary,
  onToggle,
  onSave,
  onExport,
  onRefresh,
  disabled = false,
  hasChanges = false,
  filterInfo
}) => {
  const getFilterDisplay = () => {
    const filters = [];

    if (filterInfo?.year) {
      filters.push(`Year: ${filterInfo.year}`);
    }
    if (filterInfo?.customerName) {
      filters.push(`Customer: ${filterInfo.customerName}`);
    }
    if (filterInfo?.categoryName) {
      filters.push(`Category: ${filterInfo.categoryName}`);
    }
    if (filterInfo?.brandName) {
      filters.push(`Brand: ${filterInfo.brandName}`);
    }

    return filters.length > 0 ? filters.join(' | ') : null;
  };

  const filterDisplay = getFilterDisplay();

  return (
    <div className="mx-3 my-2 flex align-items-center justify-content-between gap-2">
      <div className="view-toggle excel__header-toggle">
        <span className={isQuarterly ? 'inactive' : ''}>
          Monthly
        </span>
        <div className="custom-toggle-wrapper">
          <InputSwitch
            checked={isQuarterly}
            onChange={(e) => {
              withUnsavedChangesGuard(() => {
                onToggle?.(e.value!);
              });
            }}
            disabled={disabled}
          />
        </div>
        <span className={!isQuarterly ? 'inactive' : ''}>
          Quarterly
        </span>
      </div>

      {filterDisplay && (
        <div className="excel__filter-display">
          {filterDisplay}
        </div>
      )}

      <div className="flex gap-2 align-items-center">
        <div
          className={`excel__refresh-icon ${disabled ? 'disabled' : ''}`}
          onClick={!disabled ? onRefresh : undefined}
          title={disabled ? 'Disabled' : 'Refresh'}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? 'none' : 'auto'
          }}
        >
          <img src={Reset} alt="refresh" />
        </div>
        {!(isQuarterly || isSummary) && (
          <Button
            label="Save Changes"
            icon={<img src={SaveIcon} alt="save" className="btn-icon" />}
            className="excel__header-button p-button-outlined"
            onClick={onSave}
            disabled={disabled || !hasChanges}
          />
        )}
        <Button
          label="Export Excel"
          icon={<img src={ExcelIcon} alt="excel" className="btn-icon" />}
          className="excel__header-button--two p-button-outlined"
          onClick={onExport}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

GridHeader.defaultProps = {
  onToggle: undefined,
  onSave: undefined,
  onExport: undefined,
  onRefresh: undefined,
  disabled: false,
  hasChanges: false,
  filterInfo: undefined,
  isSummary: undefined
};

export default GridHeader;
